<template>
  <!-- width="24" height="35" -->
  <path
    d='M3.02835 18.5368C7.1672 25.6335 17.4229 25.6335 21.5618 18.5368C21.5795 18.5064 21.5806 18.4692 21.5649 18.4379C17.7339 10.8179 6.85626 10.818 3.02527 18.4379C3.00951 18.4692 3.01067 18.5064 3.02835 18.5368Z'
    stroke='#95A4C0' stroke-width='1.5' stroke-linecap='round' />
  <circle cx='12.295' cy='18.2458' r='2.34836' stroke='#95A4C0' stroke-width='1.5' />
  <path d='M20.9016 11.3607L4.03278 25.1312' stroke='#95A4C0' stroke-width='1.5' stroke-linecap='round' />
</template>
